import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8c1459c2&"
var script = {}
import style0 from "./assets/style/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./assets/style/theme.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports